<highcharts-chart
  [Highcharts]="highcharts"
  [options]="lineChartOptions"
  style="width: 100%; height: 88%; display: block"
>
</highcharts-chart>
